<h3 class="with-manual-link">
  <span i18n="@@user-statistics">Nutzerstatistik</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Insights/Nutzerstatistik"
  ></app-manual-link>
</h3>

<p
  class="text-secondary mt-1 mb-1"
  i18n="@@user-statistics-description"
>
  Mit unserem Statistik-Tracking-Feature erfasst du Erfolge, Statistiken und andere wichtige Daten ganz einfach mit
  dem Blockly-Block <b>📊 Statistik-Messpunkt</b> (Logik &amp; Code &gt; Helfer). Er speichert und verwaltet gezählte
  Werte automatisch.
  <br>
  Auf dieser Seite siehst du die erfassten Statistiken als grafische Auswertung – klar und übersichtlich. So kannst du
  Entwicklungen, Erfolge und Trends auf einen Blick erkennen und analysieren.
</p>

@for (graph of this.graphs; track $index) {
<h4>
  {{graph}}
  <div class="float-end">
    <p-menu
      #menu
      appendTo="body"
      [model]="graphContextMenu"
      [popup]="true"
    ></p-menu>

    <p-button
      (onClick)="openGraphMenu($event, menu, graph, $index)"
      [rounded]="true"
      [text]="true"
      severity="secondary"
      [raised]="true"
      icon="ri ri-more-fill"
    ></p-button>
  </div>
</h4>

<apx-chart
  #apexCharts
  [series]="this.graphData.get(graph)!.series"
  [xaxis]="this.graphData.get(graph)!.xAxis"
  [chart]="{
    type: 'line',
    height: 350,
    zoom: {
      enabled: false
    },
    toolbar: {
      show: false
    }
  }"
></apx-chart>
}